import React, { FunctionComponent, useState, useCallback } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { Navbar } from '../Navbar/Navbar';
import {
  NavigationItem,
  NavigationSidebar
} from '../NavigationSidebar/NavigationSidebar';
import { SynchronizationStatusSidebar } from '../SynchronizationStatusSidebar/SynchronizationStatusSidebar';

export type DefaultPageLayoutProps = {
  navigationItems: Array<NavigationItem>;
  onLogoutClick: () => void;
  onOpenUserProfile: () => void;
};

export const DefaultPageLayout: FunctionComponent<DefaultPageLayoutProps> =
  React.memo((props) => {
    const { children, navigationItems, onLogoutClick, onOpenUserProfile } =
      prepareProps({ props });
    const [navigationSidebarOpened, setNavigationSidebarOpened] =
      useState(false);
    const [synchronizationStatusSidebarOpened, setSynchronizationStatusOpened] =
      useState(false);

    const handleMenuIconClick = useCallback(() => {
      setNavigationSidebarOpened(true);
    }, [setNavigationSidebarOpened]);

    const handleSyncIconClick = useCallback(() => {
      setSynchronizationStatusOpened(true);
    }, [setSynchronizationStatusOpened]);

    const handleCloseNavigationSidebar = useCallback(() => {
      setNavigationSidebarOpened(false);
    }, [setNavigationSidebarOpened]);

    const handleCloseSynchronizationStatusSidebar = useCallback(() => {
      setSynchronizationStatusOpened(false);
    }, [setSynchronizationStatusOpened]);

    return (
      <>
        <Navbar
          onMenuIconClick={handleMenuIconClick}
          onSyncIconClick={handleSyncIconClick}
          data-testid="DefaultPageLayout.Navbar"
        ></Navbar>
        <NavigationSidebar
          opened={navigationSidebarOpened}
          navigationItems={navigationItems}
          onCloseSidebar={handleCloseNavigationSidebar}
          onLogoutClick={onLogoutClick}
          onOpenUserProfile={onOpenUserProfile}
          data-testid="DefaultPageLayout.NavigationSidebar"
        ></NavigationSidebar>
        <SynchronizationStatusSidebar
          opened={synchronizationStatusSidebarOpened}
          onCloseSidebar={handleCloseSynchronizationStatusSidebar}
          data-testid="DefaultPageLayout.SynchronizationStatusSidebar"
        ></SynchronizationStatusSidebar>
        <div>{children}</div>
      </>
    );
  });
